// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1163":"ae3708d2","1166":"ec683764","4247":"e70b9d3a","8810":"bc8a8a01","8859":"1f2987e2"}[chunkId] + ".chunk.css";
};